<div *ngIf="hasToBeShown()" class="bottom-right-popup">
  <div class="container popup-bkg m-0 p-0">
    <div class="row m-0 p-0">
      <div class="col m-0 p-0">
        <div class="d-flex flex-column justify-content-center align-items-end">
          <a title="Elsa" appEmptyTitle (click)="closeDialog()">
            <img src="assets/icons/icon_close_black.svg" width="24" alt="Elsa srl">
          </a>
        </div>
      </div>
    </div>
    <div class="row px-4 pb-4">
      <ng-container *ngIf="('link_popup_url' | translate ) !== 'link_popup_url';else other_content">
        <a class="col" [href]="'link_popup_url' | translate | safeUrl" target="_blank">
          <img class="popup-img" [srcset]="'link_popup_image' | translate "
               alt="Elsa popup">
        </a>
      </ng-container>
      <ng-template #other_content>
        <img class="popup-img" [srcset]="'link_popup_image' | translate "
             alt="Elsa popup">
      </ng-template>
    </div>
  </div>
</div>
